/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation, Navigate } from "react-router-dom";
import { ROUTE_ENUM } from "enums";
import { Dashboard } from "pages";
import { useEffect } from "react";
import { useGetMe } from "hooks/auth";

const ProtectedRoute: React.FC<any> = () => {
  const location = useLocation();
  const { data: authorizedUser, isLoading, refetch, isStale } = useGetMe();

  useEffect(() => {
    isStale && refetch();
  }, [location]);

  if (isLoading) {
    return null;
  }

  const isAuthenticated = !!authorizedUser;

  return isAuthenticated ? <Dashboard /> : <Navigate to={ROUTE_ENUM.LOGIN} />;
};

export default ProtectedRoute;
